export const START_SCREEN_ROUTE = "/";
export const LOGIN_SCREEN_ROUTE = "/login";
export const SIGNUP_SCREEN_ROUTE = "/signup";
export const REGISTER_SCREEN_ROUTE = "/register";
export const OTP_SCREEN_ROUTE = "/otp";

/// auth routes
export const DASHBOARD_SCREEN_ROUTE = "/dashboard";
export const SUBSCRIPTION_PHARMACY_SCREEN_ROUTE =  `${DASHBOARD_SCREEN_ROUTE}/subscription`;
export const DOCTOR_SCREEN_LOGIN_ROUTE = "/e-mareez";
export const NEWSALE_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/newsale`;
export const RETURNITEM_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/return-item`;
export const CHECKOUT_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/checkout`;
export const SALESHISTORY_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/saleshistory`;
export const RETURNHISTORY_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/returnhistory`;
export const PRODUCTSALESHISTORY_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/productsaleshistory`;
export const BATCH_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/batch`;
export const PURCHASES_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/purchases`;
export const ORDER_PURCHASE_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/order-purchase`;
export const MEDICINES_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/medicines`;
export const NONMEDICINES_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/nonmedicines`;
export const SUPPLIER_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/supplier`;
export const CATEGORY_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/category`;
export const MEDICINEFORMULA_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/medicineformula`;
export const MANUFACTURER_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/manufacturer`;
export const STAFFMANAGEMENT_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/staff-management`;
export const SHIFTMANAGEMENT_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/shift-management`;
export const SHIFTMANAGEMENT_DASHBOARD_USER_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/shift-management-user/:userId`;
export const GETTECHINAL_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/technicalhelp`;
export const RETURN_POLICY_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/return-policy`;
export const SHELF_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/shelf`;
export const CUSTOMER_HISTORY_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/customer-history`;
export const CHANGE_PASSWORD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/settings/change-password`;
export const CLINIC_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/dashboard-clinic`;
export const DOCTOR_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/dashboard-doctor`;
export const STAFF_DASHBOARD_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/dashboard-staff`;
export const CLINICS_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/clinics`;
export const APPOINTMENTS_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/appointments`;
export const NEW_APPOINTMENTS_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/new-appointments`;
export const STAFF_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/staff`;
export const PROFILE_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/profile`;
export const CLINIC_PROFILE_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/clinic-profile`;
export const STAFF_PROFILE_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/staff-profile-screen`;
export const DOCTORS_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/doctors`;
export const APPOINTMENT_REQUEST_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/appointment-request`;
export const DOCTOR_REFFERALS_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/doctor-refferals`;
export const CALENDAR_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/calendar`;
export const SPECIALITY_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/speciality`;
export const SPECIALITY_EDIT_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/speciality-edit`;
export const UNIVERSITY_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/university`;
export const DISCOUNT_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/discount`;
export const ONLINEAPPOINMENT_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/online-appoinment`;
export const DOCTORPAYMENT_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/doctor-payment`;
export const CLINICPAYMENT_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/clinic-payment`;
export const BANKDETAILS_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/bank-details`;
export const PATIENTS_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/patients`;
export const HOSPITAL_PROFILE_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/hospital-profile`;
export const PATIENT_PROFILE_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/patient-profile`;
export const SUBSCRIPTION_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/subscription-screen`;
export const OFFLINE_DOCTOR_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/offline-doctor-screen`;
export const PAYMENTATTACHMENTS_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/payment-Attachments`;
export const RELEASENOTE_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/release-notes`;
export const CLINIC_OWNER_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/clinic_owner`;
export const APPOINTMENT_DETAIL_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/appointment_detail`;
export const DOCTOR_LOGIN_SCREEN_ROUTE = `${DOCTOR_SCREEN_LOGIN_ROUTE}/doctor_login`;
export const EXPENSE_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/daily-expense`;
export const EXPENSE_CATEGORY_SCREEN_ROUTE = `${DASHBOARD_SCREEN_ROUTE}/expense-category`;

